import React, { useCallback } from "react";
import EntitiesSelector, { commonPropTypes } from "./entities-selector";
import { useAuthDataContext } from "components/auth";

const query = `
query Roles($roles: [String]) {
  roles(roles: $roles) {
    items {
      id
      name
    }
    total
  }
}
`;

const RoleSelectMultiple = ({ id = "roleIds", name = "roleIds", onChange, value, ...props }) => {
  const { hasAdminPrivileges, manageableUserRoles } = useAuthDataContext();

  const handleDataFromResponse = useCallback(data => data.roles, []);

  const handleGetValue = useCallback(element => (element ? element.id : null), []);
  const handleGetLabel = useCallback(element => (element ? element.name : null), []);

  const handleChange = name => value => {
    onChange(name)(value);
  };

  return (
    <EntitiesSelector
      id={id}
      name={name}
      multiple
      queryString={query}
      onGetDataFromResponse={handleDataFromResponse}
      onGetValue={handleGetValue}
      onGetLabel={handleGetLabel}
      variables={{ roles: hasAdminPrivileges ? null : manageableUserRoles }}
      onChange={handleChange}
      value={value}
      {...props}
    />
  );
};

RoleSelectMultiple.propTypes = {
  ...commonPropTypes,
};

export default RoleSelectMultiple;
